import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Company, PurchaseOrderDto } from '@app/models';
import { FinancialReportSignerDto } from '@app/models/financial-report-signer.dto';
import { FinancialReportUnitColumnDto } from '@app/models/financial-report-unit-column.dto';
import { FinancialReportUnitDto } from '@app/models/financial-report-unit.dto';
import { FinancialReportDto } from '@app/models/financial-report.dto';
import { CompanyService, FileService, Toaster } from '@app/services';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import {
  FinancialReportColumnInputPayload,
  FinancialReportTypeInputPayload,
  FinancialReportUnitInputPayload,
  LasgroFinancial_report,
  LasgroFinancial_report_column,
  LasgroFinancial_report_signer,
  LasgroFinancial_report_type,
  LasgroFinancial_report_unit,
  LasgroFinancial_report_unit_column,
  LasgroPanda_doc_document,
  LasgroSigner,
  LasgroUnit,
  SignerInputPayload,
} from 'api/models';
import { FinancialReportService, FinancialReportTypeService, SignerService, UnitService } from 'api/services';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import * as moment from 'moment';
import { PDFDocument, PDFTextField, TextAlignment } from 'pdf-lib';
import { concat, EMPTY, forkJoin, Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { FinancialReportTypeModal } from './financial-report-type/financial-report-type.modal';
import { VoucherGenerationModalComponent } from './voucher-generation-modal/voucher-generation-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { forEach } from 'lodash';
import Swal from 'sweetalert2';
declare var pdfform;
@Component({
  selector: 'financial-report',
  templateUrl: './financial-report.modal.html',
  styleUrls: ['./financial-report.modal.scss'],
})
export class FinancialReportModal implements OnInit, AfterViewInit {
  @Input() financialReport: FinancialReportDto;
  @Input() purchaseOrder: PurchaseOrderDto;
  @Input() supplier: Company;
  @Input() companyType;
  @Input() organizationId;
  @Input() purchaseOrderId;
  @ViewChild('printFinancialReport') printFinancialReport!: ElementRef;
  isGenerating = false;
  types = [] as LasgroFinancial_report_type[];
  units = [] as LasgroUnit[];
  signers = [] as LasgroSigner[];
  filteredUnits: LasgroUnit[];
  filteredTypes: LasgroFinancial_report_type[];
  statuses = FinancialReportStatuses;
  comments = ['Duplicate', 'Unduplicated', 'N/A'];
  newUnitName = '';
  loading = false;
  //backendCurrentColumn = 0;
  private voucherPDFBuffer: ArrayBuffer;

  constructor(
    private modalRef: NgbActiveModal,
    private financialReportService: FinancialReportService,
    private unitService: UnitService,
    private typesService: FinancialReportTypeService,
    private toaster: Toaster,
    private modal: NgbModal,
    private signerService: SignerService,
    private renderer: Renderer2,
    private httpClient: HttpClient,
    private companyService: CompanyService,
    private fileService: FileService,
    private $modal: NgbModal,
    private domSanitizer: DomSanitizer
  ) { }

  //#region COMPONENT LIFE CYCLE
  ngOnInit(): void {
    this.initSupplier();

    this.financialReport = {
      status: FinancialReportStatuses.draft,
      purchaseOrderId: this.purchaseOrderId,
      currentColumn: 1,
      financialReportUnits: [],
      financialReportSigners: [],
      financialReportType: {
        financialReportColumns: [],
      },
    } as FinancialReportDto;
    this.initFinancialReport();
    this.fillWithEmptyRaws();
    this.loadVoucherPDF();
  }

  ngAfterViewInit() {
    this.initUnits();
    this.initSigners();
    this.initTypes();
  }
  //#endregion

  //#region FR API LOGIC
  initFinancialReport() {
    this.getFinancialReport().subscribe(() => { });
  }

  getFinancialReport(): Observable<LasgroFinancial_report[]> {
    return this.financialReportService.financialReportList(this.purchaseOrderId).pipe(
      map((financialReports: LasgroFinancial_report[]) => {
        if (financialReports.length > 0) {
          financialReports.sort((a, b) => {
            const dateA = new Date(a.createAt);
            const dateB = new Date(b.createAt);
            return dateB.getTime() - dateA.getTime(); // Compare dates in descending order
          });

          // Take the latest financial report (first report after sorting)
          const latestFinancialReport = financialReports.find((x) => x.status != this.statuses.closed);

          if (latestFinancialReport) {
            this.financialReport = latestFinancialReport as FinancialReportDto;
            // this.backendCurrentColumn = this.financialReport.currentColumn;
            // if (this.isCustomer() && this.checkStatus(this.statuses.draft)) {
            //   this.backendCurrentColumn = this.financialReport.financialReportType.financialReportColumns.length;
            // }
            if (this.financialReport.financialReportType) {
              this.financialReport.financialReportType.financialReportColumns = this.financialReport.financialReportType.financialReportColumns.sort((a, b) => {
                return a.order - b.order
              })
            }
            this.markUnitsAsAdded(this.financialReport.financialReportUnits);
            this.markSignersAsAdded(this.financialReport.financialReportSigners);
            this.fillWithEmptyRaws();
            this.financialReport.financialReportUnits.forEach((unit: FinancialReportUnitInputPayload) => {
              if (!unit.columns || unit.columns.length == 0) {
                this.setUnitColumns(unit);
              }
            });
            this.financialReport.financialReportUnits.forEach((unit) => {
              this.recalculate(unit, null, true);
            });
          }

          if (this.financialReport.id && !this.financialReport.isFROpenedFirstTime && !this.isCustomer()) {
            this.financialReportService
              .financialReportFinancialReportOpenedFirstTime({
                purchaseOrderID: this.purchaseOrderId,
                financialReportID: this.financialReport.id,
              })
              .subscribe(() => { });
          }
          return financialReports;
        }
      }),
    );
  }

  // when customer submit vendor get alert in mail and notification
  onSubmitClick() {
    this.loading = true;
    if (this.isCustomer()) {
      let saveRequests = concat(this.saveFinancialReport(), this.submitLogic(), this.getFinancialReport());
      let addRequests = concat(
        this.addFinancialReport(),
        this.getFinancialReport().pipe(
          switchMap(() => {
            return this.submitLogic();
          }),
        )
      );
      if (this.financialReport.id) {
        saveRequests
          .pipe(
            tap({
              complete: () => {
                this.loading = false;
              },
            }),
          )
          .subscribe(
            () => { },
            (error) => {
              this.loading = false;
              this.toaster.show('error', '', `Some error while saving data`);
            },
          );
      } else {
        addRequests
          .pipe(
            tap({
              complete: () => {
                this.loading = false;
              },
            }),
          )
          .subscribe(
            () => { },
            (error) => {
              this.loading = false;
              this.toaster.show('error', '', `Some error while saving data`);
            },
          );
      }
    } else {
      this.submitWithSignerCreationCheck();
    }
  }

  submitLogic(): Observable<void> {
    return this.financialReportService
      .financialReportSubmit({
        purchaseOrderID: this.purchaseOrderId,
        financialReportID: this.financialReport.id,
      })
      .pipe(
        map(() => {
          this.toaster.show('success', '', `Financial report was submitted`);
        }),
      );
  }

  getSignatureFieldTitle(financialReportSigner) {
    switch (financialReportSigner.signatureField) {
      case 'SIGNATURE': {
        return 'vendor';
      }
      case 'SIGNATURE1': {
        return 'Department Receiving Clerk';
      }
      case 'SIGNATURE2': {
        return 'Authorized Department Official';
      }
    }
  }


  async addFile(file, fileName) {
    const formData: FormData = new FormData();
    formData.append('file', file, fileName);
    this.companyService
      .addFileToPo(
        this.purchaseOrder.customer_id,
        this.purchaseOrder.id,
        formData,
        false,
        false,
        '$submitted_voucher_documents',
        true,
        'N/A',
      )
      .subscribe(
        (_) => {
          this.toaster.show('success', 'Success', 'File has been added');
        },
        (error) => {
          console.error(error);
          const errMsg =
            error.error && error.error.detail ? error.error.detail : 'An error ocurred while uploading a file.';
          this.toaster.show('error', 'File upload', errMsg);
        },
      );
  }


  sendFinancialReport(file: Blob) {
    this.financialReportService
      .financialReportSendFinancialReport({
        purchaseOrderID: this.purchaseOrderId,
        financialReportID: this.financialReport.id,
        file,
      })
      .subscribe((document: LasgroPanda_doc_document) => {
        this.toaster.show('success', '', `Financial report was sended to supplier`);
      });
  }

  generatePDF() {
    this.loading = true;
    this.generateFinancialReport(false).subscribe((file) => {
      this.loading = false;
      if (file) {
        this.fileService.viewPdf(file, `financial-report-preview.pdf`);
      }
    });
  }

  async savePDFToSectionC() {
    const formattedDate = moment().format('MM/DD/YYYY HH:mm');
    let currentReportColumn = this.financialReport.financialReportType.financialReportColumns.find(
      (x) => x.order == this.financialReport.currentColumn,
    );
    let placeholder = `(${formattedDate}) Saved FR file state in period (${currentReportColumn.name}) for vendor (${this.supplier.name}).pdf`
    const { value: fileName, isDismissed } = await Swal.fire({
      title: 'Enter a name for the file',
      input: 'text',
      inputValue: placeholder,
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'File name cannot be empty';
        }
      }
    });
    if (isDismissed) {
      return;
    }
    this.loading = true;
    this.generateFinancialReport(false).subscribe((file) => {
      this.loading = false;
      this.addFile(file, fileName)
    });
  }

  onSaveClick() {
    this.loading = true;

    // Filter out signers without a signerID (signers that need to be added)
    let notAddedSigners = this.financialReport.financialReportSigners.filter(x => !x.signerID && x.companyType == this.companyType);

    // Prepare an array of addSigner requests
    let addSignersRequest = notAddedSigners.map(signer => this.addSigner(signer));

    // Use concat to execute signer requests sequentially, one by one
    let signersAdd$ = addSignersRequest.length > 0 ? forkJoin(...addSignersRequest) : of(null);

    // Wait for all signers to be added, then save or add the financial report
    signersAdd$.pipe(
      switchMap(() => {
        debugger
        // After all signers are added, save or add the financial report
        if (!this.financialReport.id) {
          return this.addFinancialReport(); // Add if the report doesn't exist
        } else {
          return this.saveFinancialReport(); // Otherwise save it
        }
      })
    ).subscribe(
      (response) => {
        this.initFinancialReport();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.toaster.show('error', '', `Some error occurred while saving data`);
      }
    );
  }
  mapFinancialReportRequest(): FinancialReportDto {
    if (!this.financialReport.status) {
      this.financialReport.status = FinancialReportStatuses.draft;
    }
    if (!this.financialReport.currentColumn) {
      this.financialReport.currentColumn = 1;
    }
    let request = JSON.parse(JSON.stringify(this.financialReport)) as FinancialReportDto;
    // if (this.financialReport.id) {
    //   request.currentColumn = this.backendCurrentColumn;
    //   if (this.isCustomer() && this.checkStatus(this.statuses.draft)) {
    //     request.currentColumn = this.financialReport.currentColumn;
    //   }
    // }
    request.financialReportSigners = this.financialReport.financialReportSigners.filter(
      (x: FinancialReportSignerDto) => x.isAdded,
    );
    request.financialReportUnits = this.financialReport.financialReportUnits.filter(
      (x: FinancialReportUnitDto) => x.isAdded,
    );
    request.financialReportUnits.forEach((unit: FinancialReportUnitDto) => {
      this.removeEmptyUnits(unit);
    });
    return request;
  }

  saveFinancialReport(): Observable<FinancialReportDto> {
    return this.financialReportService.financialReportSave(this.mapFinancialReportRequest()).pipe(
      map((response) => {
        this.toaster.show('success', '', `Financial report was saved successfully`);
        return response;
      }),
    );
  }

  addFinancialReport(): Observable<string> {
    return this.financialReportService.financialReportAdd(this.mapFinancialReportRequest()).pipe(
      map((response) => {
        this.toaster.show('success', '', `Financial report was created successfully`);
        return response;
      }),
    );
  }

  fillWithEmptyRaws() {
    if (this.isCustomer() && this.financialReport.status == this.statuses.draft) {
      this.fillWithEmptyUnits();
    }
    this.fillWithEmptySigners();
  }

  //#endregion

  //#region FR UNIT LOGIC

  filterFinancialReportUnits(units: FinancialReportUnitDto[], checkUnits: boolean = false) {
    if (!units) {
      return [];
    }
    if (checkUnits && !this.isCustomer()) {
      return units.filter((x) => x.isAdded);
    }
    if (!checkUnits) {
      return units.filter((x) => x.isAdded);
    }
    return units;
  }

  fillWithEmptyUnits() {
    var level = 3;
    let createEmptyAllLevels = (unit: FinancialReportUnitDto, currentLevel: number) => {
      currentLevel++;
      if (!unit.childs) {
        unit.childs = [];
      }
      unit.childs.forEach((child) => {
        if (!child.childs) {
          child.childs = [];
        }
        if (!child.childs.some((x: FinancialReportUnitDto) => !x.isAdded) && currentLevel < level) {
          createEmptyAllLevels(child, currentLevel);
        }
      });
      this.createEmptySubUnit(unit);
    };
    if (!this.financialReport.financialReportUnits) {
      this.financialReport.financialReportUnits = [];
    }
    if (!this.financialReport.financialReportUnits.some((x: FinancialReportUnitDto) => !x.isAdded)) {
      this.financialReport.financialReportUnits.forEach((unit) => {
        let currentLevel = 1;
        if (!unit.childs) {
          unit.childs = [];
        }
        if (!unit.childs.some((x: FinancialReportUnitDto) => !x.isAdded)) {
          createEmptyAllLevels(unit, currentLevel);
        }
      });
      this.createEmptyUnit();
    }
  }

  markUnitsAsAdded(units: FinancialReportUnitDto[]) {
    if (!units) {
      return;
    }
    units.forEach((unit: FinancialReportUnitDto) => {
      unit.isAdded = true;
      unit.expanded = true;
      this.markUnitsAsAdded(unit.childs);
    });
  }

  removeEmptyUnits(unit: FinancialReportUnitDto) {
    if (!unit.childs) {
      return;
    }
    unit.childs = unit.childs.filter((x: FinancialReportUnitDto) => x.isAdded);
    unit.childs.forEach((child: FinancialReportUnitDto) => this.removeEmptyUnits(child));
  }

  createEmptySubUnit(unit: FinancialReportUnitInputPayload) {
    if (!unit.childs) {
      unit.childs = [];
    }
    let subUnit = {
      financialReportId: this.financialReport.id,
      name: null,
      contractualAmount: 0,
      pricePerUnit: 0,
      comment: '',
      parentId: unit.id,
      columns: [],
      childs: [],
      isCalculating: true,
      expanded: true,
    } as FinancialReportUnitDto;
    this.setUnitColumns(subUnit);
    unit.childs.push(subUnit);
  }

  addSubUnit(unit: FinancialReportUnitDto, parent: FinancialReportUnitDto, level: number) {
    unit.isAdded = true;
    this.createEmptySubUnit(parent);
    if (level < 2) {
      this.createEmptySubUnit(unit);
    }
  }

  createEmptyUnit() {
    let unit = {
      financialReportId: this.financialReport.id,
      name: null,
      contractualAmount: 0,
      pricePerUnit: 0,
      comment: '',
      parentId: null,
      columns: [],
      childs: [],
      isCalculating: true,
      expanded: true,
    } as FinancialReportUnitDto;
    this.setUnitColumns(unit);
    this.financialReport.financialReportUnits.push(unit as LasgroFinancial_report_unit);
  }

  addUnit(unit: FinancialReportUnitDto) {
    unit.isAdded = true;
    this.createEmptyUnit();
    this.createEmptySubUnit(unit);
  }

  removeUnitFromArray(unit, array) {
    let index = array.indexOf(unit);
    array.splice(index, 1);
  }
  //#endregion

  //#region FR SIGNERS LOGIC
  fillWithEmptySigners() {
    if (!this.financialReport.financialReportSigners) {
      this.financialReport.financialReportSigners = [];
    }
    if (this.financialReport != null && this.financialReport.financialReportSigners != null) {
      this.createEmptySigners();
      this.financialReport.financialReportSigners.sort((a, b) => {
        return a.signatureField.localeCompare(b.signatureField);
      });

    }
  }

  getFinancialReportSigners(): FinancialReportSignerDto[] {
    let result: FinancialReportSignerDto[] = [];

    if (this.financialReport && this.financialReport.financialReportSigners && this.financialReport.financialReportSigners.length > 0) {

      if (!this.isCustomer()) {
        result = this.financialReport.financialReportSigners.filter(x => x.companyType == 'supplier')
      } else {
        result = this.financialReport.financialReportSigners.filter(x => x.companyType == 'customer')
      }
    }
    return result;
  }

  markSignersAsAdded(signer: FinancialReportSignerDto[]) {
    if (!signer) {
      this.financialReport.financialReportSigners = [];
      return;
    }
    signer.forEach((signer: FinancialReportSignerDto) => {
      signer.isAdded = true;
    });
  }

  createEmptySigners() {
    let supplierCount = this.financialReport.financialReportSigners.filter(signer => signer.companyType === 'supplier').length;
    let customerCount = this.financialReport.financialReportSigners.filter(signer => signer.companyType === 'customer').length;

    // Ensure there's at least one supplier signer
    if (supplierCount < 1) {
      let signatureField = `SIGNATURE`
      this.createEmptySigner('supplier', signatureField);
    }

    // Ensure there are at least two customer signers
    while (customerCount < 2) {
      customerCount++;
      let signatureField = `SIGNATURE${customerCount}`
      this.createEmptySigner('customer', signatureField);
    }
  }

  createEmptySigner(companyType: 'supplier' | 'customer', signatureField: string, signerID: string | null = null,) {
    let signer = {
      financialReportID: this.financialReport.id,
      signerID: signerID,
      signatureField: signatureField,
      companyType: companyType,
      signer: {
        organizationId: this.organizationId,
      },
    } as FinancialReportSignerDto;

    // Add signer to the beginning of the signers array
    this.financialReport.financialReportSigners.unshift(signer as LasgroFinancial_report_signer);
    this.financialReport.financialReportSigners.sort((a, b) => {
      return a.signatureField.localeCompare(b.signatureField);
    })
  }

  onSendVoucherClick() {
    if (!this.financialReport.financialReportSigners || !this.financialReport.financialReportSigners.every(x => x.isAdded || x.signer.email != null)) {
      this.toaster.show('error', '', 'All signer is required');
      return;
    }
    this.generateVoucherPDF().subscribe(
      (file: Blob) => {
        this.loading = false;
        if (file) {
          if (!this.financialReport.isVoucherOpenedFirstTime && this.isCustomer()) {
            this.financialReportService
              .financialReportVoucherOpenedFirstTime({
                purchaseOrderID: this.purchaseOrderId,
                financialReportID: this.financialReport.id,
              })
              .subscribe(() => { });
          }
          let activeModal = this.$modal.open(VoucherGenerationModalComponent, {
            size: 'xl',
            container: 'nb-layout',
            backdrop: 'static',
            windowClass: 'modal-fit-content',
          } as NgbModalOptions);

          activeModal.componentInstance.companyType = this.companyType;
          activeModal.componentInstance.purchaseOrder = this.purchaseOrder;
          activeModal.componentInstance.file = file;
          activeModal.componentInstance.supplier = this.supplier;
          activeModal.componentInstance.financialReport = this.financialReport;
          activeModal.componentInstance.pdfSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(file),
          );

        }
      },
      (error) => {
        this.loading = false;
        this.toaster.show('error', '', `Some error while saving data`);
      },
    );
  }

  submitWithSignerCreationCheck() {
    let financialReportSigner = this.financialReport.financialReportSigners[0];
    if (!financialReportSigner || (!financialReportSigner.isAdded && !financialReportSigner.signer.email)) {
      this.toaster.show('error', '', 'Signer is required');
      return;
    }
    if (this.financialReport.currentColumn < this.financialReport.financialReportType.financialReportColumns.length) {
      this.financialReport.currentColumn++;
    }
    this.loading = true;
    if (!financialReportSigner.signer.id) {
      financialReportSigner.signer.signingOrder = 3;
      concat(
        this.addSigner(financialReportSigner).pipe(
          switchMap((file: Blob) => {
            return this.saveFinancialReport();
          }),
        ),
        this.getFinancialReport(),
        this.generateFinancialReport(true).pipe(
          switchMap((file: Blob) => {
            if (file) {
              this.fileService.viewPdf(file, `financial-report-preview.pdf`, true).subscribe((result) => {
                if (result == 'confirmed') {
                  return this.sendFinancialReport(file);
                } else {
                  return EMPTY;
                }
              });
            }
            return EMPTY;
          }),
        ),
      )
        .pipe(
          tap({
            complete: () => {
              this.loading = false;
            },
          }),
        )
        .subscribe(
          () => { },
          (error) => {
            this.loading = false;
            this.toaster.show('error', '', `Some error while saving data`);
          },
        );
    } else {
      concat(
        this.saveFinancialReport(),
        this.getFinancialReport(),
        this.generateFinancialReport(true).pipe(
          switchMap((file: Blob) => {
            if (file) {
              this.fileService.viewPdf(file, `financial-report-preview.pdf`, true).subscribe((result) => {
                if (result == 'confirmed') {
                  this.sendFinancialReport(file);
                }
              });
            }
            return EMPTY;
          }),
        ),
      )
        .pipe(
          tap({
            complete: () => {
              this.loading = false;
            },
          }),
        )
        .subscribe(
          () => { },
          (error) => {
            this.loading = false;
            this.toaster.show('error', '', `Some error while saving data`);
          },
        );
    }

    //this.createEmptySigner();
  }

  addSigner(financialReportSigner: FinancialReportSignerDto): Observable<any> {
    const lastChar = financialReportSigner.signatureField.charAt(financialReportSigner.signatureField.length - 1);
    if (!isNaN(Number(lastChar))) {
      financialReportSigner.signer.signingOrder = Number(lastChar) + 1;
    } else {
      financialReportSigner.signer.signingOrder = 1
    }
    return this.signerService.signerAdd(financialReportSigner.signer).pipe(
      map((result: any) => {
        financialReportSigner.isAdded = true;
        financialReportSigner.signerID = result;
        financialReportSigner.signer.id = result;
        return result;
      }),
    );
  }

  removeSigner(financialReportSigner: FinancialReportSignerDto) {
    const type = financialReportSigner.companyType;
    const signature = financialReportSigner.signatureField;
    let index = this.financialReport.financialReportSigners.indexOf(financialReportSigner);
    this.financialReport.financialReportSigners.splice(index, 1);
    this.createEmptySigner(type == 'customer' ? 'customer' : 'supplier', signature);
  }
  //#endregion

  //#region ADDITIONAL LOGIC
  initSupplier() {
    this.companyService.getById(this.purchaseOrder.supplier_id).subscribe((supplier: Company) => {
      this.supplier = supplier;
    });
  }
  //#endregion

  //#region FR FRONT LOGIC
  public closeModal() {
    this.modalRef.close();
  }

  public getPointer(character: string, count: number): string {
    return character.repeat(count);
  }

  public checkStatus(status: string) {
    return this.financialReport.status && this.financialReport.status == status;
  }

  public isCustomer() {
    return this.companyType == 'customer';
  }

  public isUnitExist(unit) {
    return this.financialReport.financialReportUnits.some(
      (x: FinancialReportUnitDto) => (x.name == unit.name && x.isAdded) || this.isUnitExistInArray(unit, x.childs),
    );
  }
  public isUnitExistInArray(unit, units) {
    if (!units || units.length == 0) return false;
    return units.some((x) => (x.name == unit.name && x.isAdded) || this.isUnitExistInArray(unit, x.childs));
  }

  public isSignerExist(signer) {
    return this.financialReport.financialReportSigners.some(
      (x: FinancialReportSignerDto) => x.signer.email == signer.email && x.isAdded,
    );
  }

  public isCanAddUnit(unit: FinancialReportUnitDto) {
    return unit.comment && unit.name;
  }

  public isCurrentColumnOrder(column: LasgroFinancial_report_unit_column) {
    let currentColumn = this.financialReport.financialReportType.financialReportColumns.find(
      (x) => x.order == this.financialReport.currentColumn,
    );
    return currentColumn.id == column.financialReportColumnID;
  }

  public isSomeActiveChilds(unit: FinancialReportUnitDto) {
    return unit.childs && unit.childs.some((x) => x.isAdded);
  }

  public isBalanceRemainingNegative() {
    return this.financialReport.financialReportUnits.some((x) => x.balanceRemaining < 0);
  }

  public isFinancialReportValid() {
    return this.financialReport.taxPayerId && this.financialReport.financialReportTypeId;
  }

  public isAnyUnitAmmountAdded() {
    return this.financialReport.financialReportUnits.some((x) => x.contractualAmount > 0);
  }

  isTotalMaxPrriceLessThanBalanceRemaining() {
    return this.financialReport.totalMaxPrice && 0 > this.calculateTotal('balanceRemaining');
  }

  onInputChange(inputRef: HTMLInputElement, signer: SignerInputPayload): void {
    const sanitizedValue = inputRef.value.replace(/[^a-zA-Z0-9]/g, ''); // Allow only letters and numbers
    signer.role = inputRef.value = sanitizedValue;
  }
  //#endregion

  //#region FR GENERATION LOGIC
  public generateFinancialReport(withSignature: boolean): Observable<Blob> {
    this.isGenerating = true;
    return new Observable<Blob>((observer) => {
      setTimeout(() => {
        let result: Blob;
        const element = this.printFinancialReport.nativeElement as HTMLElement;
        const doc = new jsPDF('l', 'px', 'A4');
        doc.setFontSize(10);
        const pdfWidth = doc.internal.pageSize.getWidth(); // A4 width in px
        const pdfHeight = doc.internal.pageSize.getHeight(); // A4 width in px

        const widhtScale = element.clientWidth / pdfWidth;
        const printableRows = element.querySelectorAll('.print-row');
        const totalHeight = Array.from(printableRows).reduce(
          (sum, element) => sum + element.getBoundingClientRect().height,
          0,
        );
        const scaledElementWidth = element.clientWidth;
        const scaledElementHeigt = totalHeight;
        const scaledPdfWidth = pdfWidth;
        const scaledPdfHeight = pdfHeight * widhtScale;
        html2canvas(element, { scale: 1 }).then((canvas) => {
          let htmlPosition = 0;
          let previousHtmlPosition = 0;
          let currentPage = 0;
          let lastRowPosition = 0;
          // Slice the image and append each slice to the container
          while (lastRowPosition < printableRows.length - 1) {
            for (let i = lastRowPosition; i < printableRows.length; i++) {
              let currentRow = printableRows[i];
              let scaledRawHeight = currentRow.getBoundingClientRect().height;
              // If the slice is within the container height, show it, otherwise hide it
              if (htmlPosition - previousHtmlPosition + scaledRawHeight <= scaledPdfHeight) {
                htmlPosition += scaledRawHeight;
                lastRowPosition = i;
              }
            }
            let sliceCanvas = document.createElement('canvas');
            sliceCanvas.width = scaledElementWidth;
            sliceCanvas.height = scaledElementHeigt;

            let scaledCurrentHeight = htmlPosition - previousHtmlPosition;
            currentPage++;
            doc.setPage(currentPage);
            let ctx = sliceCanvas.getContext('2d');
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
            ctx.drawImage(
              canvas,
              0, //sx - canvas width start point to cut
              previousHtmlPosition, //sy - canvas height start point to cut
              scaledElementWidth, //sw - canvas width
              scaledCurrentHeight, //sh - canvas height
              0, //dx - page width start point
              0, //dy - page height start point
              scaledElementWidth, //dw - page width
              scaledElementHeigt, //dh - page height
            );
            // Append the slice to the container
            doc.addImage(sliceCanvas, 'JPEG', 7.5, 7.5, pdfWidth, scaledCurrentHeight / widhtScale, undefined, 'FAST');

            if (lastRowPosition < printableRows.length - 1) {
              doc.addPage('A4', 'l');
              previousHtmlPosition = htmlPosition;
            }
          }
          let position = (htmlPosition - previousHtmlPosition) / widhtScale;
          if (position < 80) {
            position = 80;
            doc.addPage('A4', 'l');
            currentPage++;
            doc.setPage(currentPage);
          }

          //           doc.setFont('helvetica', 'bold');
          //           doc.text('CERTIFICATE', 140, position - 80);
          //           doc.setFont('helvetica', 'normal');
          //           doc.text(`The undersigned certifies that: the expenditures as shown above have been made for the Project identified above and supporting rolls or absthacts,
          // vouchers and other documents which are deemed a part of hereto are just, thue and correct and have been duly authorized; that all service units
          // have been delivered in the numbers indicated herein; and that all expenditures have been made in accordance with the approved project proposal.
          // Records are attached and also available in the files to support these costs.`, 10, position - 75);
          let year = moment().format('YYYY');
          let generationDate = moment().format('MM/DD/YYYY');
          (this.financialReport.financialReportSigners as FinancialReportSignerDto[])
            .filter((x) => x.isAdded && x.companyType == 'supplier')
            .forEach((financialReportSigner: FinancialReportSignerDto, i: number) => {
              // first row
              doc.setFont('helvetica', 'bold');
              doc.text('Signature/Project Director', 10, position - 60);
              doc.setFont('helvetica', 'normal');
              if (withSignature) {
                doc.text(financialReportSigner.signer.code, 10, position - 30);
              }
              doc.setFont('helvetica', 'bold');
              doc.text('Title', 10, position - 20);
              doc.setFont('helvetica', 'normal');
              doc.text(
                `${financialReportSigner.signer.firstName} ${financialReportSigner.signer.lastName}`,
                10,
                position - 10,
              );

              // second row
              doc.setFont('helvetica', 'bold');
              doc.text('Date', 400, position - 60);
              doc.setFont('helvetica', 'normal');
              doc.text(generationDate, 400, position - 50);
              doc.setFont('helvetica', 'bold');
              doc.text('Agency', 400, position - 40);
              doc.setFont('helvetica', 'normal');
              doc.text(this.supplier.name, 400, position - 30);
              doc.setFont('helvetica', 'bold');
              doc.text('DSSLM', 400, position - 20);
              doc.setFont('helvetica', 'normal');
              doc.text(`${year}-${this.purchaseOrder.customer_po_number}`, 400, position - 10);

              // third row
              doc.setFont('helvetica', 'bold');
              doc.text('Office Use Only', 460, position - 60);
            });
          result = doc.output('blob');
          this.toaster.show('success', '', 'Financial report was generated successfully');
          this.isGenerating = false;
          observer.next(result);
          observer.complete();
          return result;
        });
      }, 10);
    });
  }

  loadVoucherPDF() {
    this.httpClient
      .get('https://rcdss-documents.s3.amazonaws.com/Electronic+Voucher.pdf', { responseType: 'arraybuffer' })
      .subscribe((result: ArrayBuffer) => {
        this.voucherPDFBuffer = result;
      });
  }

  public generateVoucherPDF(): Observable<Blob> {
    return new Observable<Blob>((observer) => {
      setTimeout(async () => {
        let fileBuffer = this.voucherPDFBuffer;
        const pdfDoc = await PDFDocument.load(fileBuffer);
        let currentReportColumn = this.financialReport.financialReportType.financialReportColumns.find(
          (x) => x.order == this.financialReport.currentColumn,
        );
        if (!currentReportColumn) {
          this.toaster.show('error', 'Columns not provided', 'Please add columns to report');
          return;
        }

        var frSigner = this.financialReport.financialReportSigners.find((x: FinancialReportSignerDto) => x.signatureField == 'SIGNATURE')
        // Get the form fields
        const form = pdfDoc.getForm();
        let totalValue = 0;
        let fontSize = 7;
        this.financialReport.financialReportUnits.forEach((unit: FinancialReportUnitDto, i: number) => {
          if (i < 7 && unit.isAdded) {
            this.addSplittedText(form.getTextField(`DESCRIPTIONRow${i + 1}`), fontSize, unit.name);

            let currentColumn = unit.columns.find((x) => x.financialReportColumnID == currentReportColumn.id);
            this.addSplittedText(form.getTextField(`Qty${i + 1}`), fontSize, currentColumn.value.toString());

            this.addSplittedText(form.getTextField(`AmountRow${i + 1}`), fontSize, currentColumn.totalValue.toString());

            totalValue += currentColumn.totalValue;

            this.addSplittedText(form.getTextField(`Unit PriceRow${i + 1}`), fontSize, unit.pricePerUnit.toString());

            this.addSplittedText(form.getTextField(`Unit${i + 1}`), fontSize, 'each');
          }
        });
        this.addSplittedText(form.getTextField(`VendorName`), fontSize, this.supplier.name);
        if (frSigner && frSigner.signer) {
          this.addSplittedText(form.getTextField(`VendorName2`), fontSize, `${frSigner.signer.firstName} ${frSigner.signer.lastName}`);
        }
        this.addSplittedText(form.getTextField(`Address1`), fontSize, this.supplier.address1);
        this.addSplittedText(form.getTextField(`Address2`), fontSize, this.supplier.address2);
        this.addSplittedText(
          form.getTextField(`CityAndState`),
          fontSize,
          `${this.supplier.city} ${this.supplier.region}`,
        );
        this.addSplittedText(form.getTextField(`ZIPCode`), fontSize, this.supplier.postal_code.toString());
        this.addSplittedText(form.getTextField(`TaxpayerID`), fontSize, this.financialReport.taxPayerId);
        this.addSplittedText(form.getTextField(`TOTAL`), fontSize, totalValue.toFixed(2));
        this.addSplittedText(form.getTextField(`TOTAL2`), fontSize, totalValue.toFixed(2));
        if (frSigner && frSigner.signer) {
          this.addSplittedText(form.getTextField(`SignerName`), fontSize, frSigner.signer.role);
        }
        this.addSplittedText(form.getTextField(`ColumnName`), fontSize, currentReportColumn.name);

        let generationDate = moment().format('MM/DD/YYYY');
        this.addSplittedText(form.getTextField(`SendingDate`), fontSize, generationDate);
        // Get the field position
        fileBuffer = (await pdfDoc.save()).buffer;

        var result = new Blob([fileBuffer], { type: 'application/pdf' });
        observer.next(result);
        observer.complete();
        return result;
      }, 10);
    });
  }

  addSplittedText(textField: PDFTextField, fontSize, value) {
    textField.setFontSize(fontSize);
    textField.enableMultiline();
    textField.setAlignment(TextAlignment.Left);
    textField.setText(value);
  }

  private getINCH() {
    return 3.779527559; // Default jsPDF inch
  }

  //#endregion

  //#region FR CALCULATION LOGIC
  calculateTotal(field: string): number {
    switch (field) {
      case 'comulativeExp': {
        return this.financialReport.financialReportUnits
          .filter((x) => x.isAdded)
          .reduce((sum, unit) => sum + unit.totalComulativeExp, 0);
      }
      case 'balanceRemaining': {
        if (!this.financialReport.totalMaxPrice) {
          return this.financialReport.financialReportUnits
            .filter((x) => x.isAdded)
            .reduce((sum, unit) => sum + unit.totalBalanceRemaining, 0);
        } else {
          return (
            this.financialReport.totalMaxPrice -
            this.financialReport.financialReportUnits
              .filter((x) => x.isAdded)
              .reduce((sum, unit) => sum + unit.totalComulativeExp, 0)
          );
        }
      }
      case 'contractualAmount': {
        return this.financialReport.financialReportUnits
          .filter((x) => x.isAdded)
          .reduce((sum, unit) => sum + unit.totalContractualAmount, 0);
      }
    }
    return 0;
  }

  recalculateWithValidation(
    event,
    unit: FinancialReportUnitDto,
    unitColumn: FinancialReportUnitColumnDto = null,
    withColumns = false,
  ) {
    if (this.isSomeActiveChilds(unit)) {
    }
  }

  recalculate(unit: FinancialReportUnitDto, unitColumn: FinancialReportUnitColumnDto = null, withColumns = false) {
    if (this.isSomeActiveChilds(unit)) {
      if (unitColumn != null) {
        let firstLevelColumn = unit.columns.find(
          (x) => x.financialReportColumnID == unitColumn.financialReportColumnID,
        );
        let columnResult = this.calculateColumnChild(unit, unitColumn.financialReportColumnID);
        firstLevelColumn.value = columnResult.count;
        firstLevelColumn.totalValue = columnResult.total;
      }
      if (withColumns) {
        unit.columns.forEach((column: FinancialReportUnitColumnDto) => {
          let columnResult = this.calculateColumnChild(unit, column.financialReportColumnID);
          column.value = columnResult.count;
          column.totalValue = columnResult.total;
        });
      }

      let contractualAmmountResult = this.calculateContractualAmmountChild(unit);
      let comulativeExpResult = this.calculateComulativeExpChild(unit);
      if (!this.financialReport.totalMaxPrice) {
        let balanceRemainingResult = this.calculateBalanceRemainingChild(unit);
        unit.balanceRemaining = balanceRemainingResult.count;
        unit.totalBalanceRemaining = balanceRemainingResult.total;
      }

      unit.contractualAmount = contractualAmmountResult.count;
      unit.comulativeExp = comulativeExpResult.count;

      unit.totalContractualAmount = contractualAmmountResult.total;
      unit.totalComulativeExp = comulativeExpResult.total;
    } else {
      unit.comulativeExp = Number(unit.columns.reduce((sum, column) => sum + column.value, 0).toFixed(2));
      if (!this.financialReport.totalMaxPrice) {
        unit.balanceRemaining = Number(
          (unit.contractualAmount - unit.columns.reduce((sum, column) => sum + column.value, 0)).toFixed(2),
        );
        unit.totalBalanceRemaining = Number((unit.balanceRemaining * unit.pricePerUnit).toFixed(2));
      }

      unit.totalContractualAmount = Number((unit.contractualAmount * unit.pricePerUnit).toFixed(2));
      unit.totalComulativeExp = Number((unit.comulativeExp * unit.pricePerUnit).toFixed(2));
      if (unitColumn != null) {
        unitColumn.totalValue = Number((unitColumn.value * unit.pricePerUnit).toFixed(2));
      }
      if (withColumns) {
        unit.columns.forEach((column: FinancialReportUnitColumnDto) => {
          column.totalValue = Number((column.value * unit.pricePerUnit).toFixed(2));
        });
      }
    }
  }

  calculateTotalColumn(col: LasgroFinancial_report_column): number {
    let total = 0;
    this.financialReport.financialReportUnits.forEach((financialReportUnit) => {
      financialReportUnit.columns.forEach((column) => {
        if (column.financialReportColumnID == col.id) {
          total += column.totalValue;
        }
      });
    });
    return Number(total.toFixed(2));
  }

  calculateColumnChild(unit: FinancialReportUnitDto, columnId: string): { count: number; total: number } {
    let count = 0;
    let total = 0;
    if (!unit.childs) {
      unit.childs = [];
    }
    unit.childs.forEach((child: FinancialReportUnitDto) => {
      if (child.isAdded && child.isCalculating) {
        let childColumn = child.columns.find((x) => x.financialReportColumnID == columnId);
        childColumn.totalValue = childColumn.value * child.pricePerUnit;
        total += childColumn.totalValue;
        count += childColumn.value;
        if (!child.childs) {
          child.childs = [];
        }
        let res = this.calculateColumnChild(child, columnId);
        total += res.total;
        count += res.count;
      }
    });
    return { count: Number(count.toFixed(2)), total: Number(total.toFixed(2)) };
  }

  calculateContractualAmmountChild(unit: FinancialReportUnitDto): { count: number; total: number } {
    let count = 0;
    let total = 0;
    if (!unit.childs) {
      unit.childs = [];
    }
    unit.childs.forEach((child: FinancialReportUnitDto) => {
      if (child.isAdded && child.isCalculating) {
        child.totalContractualAmount = child.contractualAmount * child.pricePerUnit;
        count += child.contractualAmount;
        total += child.totalContractualAmount;
        if (!child.childs) {
          child.childs = [];
        }
        let res = this.calculateContractualAmmountChild(child);
        total += res.total;
        count += res.count;
      }
    });
    return { count: Number(count.toFixed(2)), total: Number(total.toFixed(2)) };
  }

  calculateComulativeExpChild(financialReportUnit: FinancialReportUnitDto): { count: number; total: number } {
    let count = 0;
    let total = 0;
    if (!financialReportUnit.childs) {
      financialReportUnit.childs = [];
    }
    financialReportUnit.childs.forEach((child: FinancialReportUnitDto) => {
      if (child.isAdded && child.isCalculating) {
        child.comulativeExp = child.columns.reduce((sum, column) => sum + column.value, 0);
        child.totalComulativeExp = child.comulativeExp * child.pricePerUnit;
        count += child.comulativeExp;
        total += child.totalComulativeExp;
        if (!child.childs) {
          child.childs = [];
        }
        let res = this.calculateComulativeExpChild(child);
        total += res.total;
        count += res.count;
      }
    });
    return { count: Number(count.toFixed(2)), total: Number(total.toFixed(2)) };
  }

  calculateBalanceRemainingChild(financialReportUnit: FinancialReportUnitDto): { count: number; total: number } {
    let count = 0;
    let total = 0;
    if (!financialReportUnit.childs) {
      financialReportUnit.childs = [];
    }
    financialReportUnit.childs.forEach((child: FinancialReportUnitDto) => {
      if (child.isAdded && child.isCalculating) {
        child.balanceRemaining = child.contractualAmount - child.columns.reduce((sum, column) => sum + column.value, 0);
        child.totalBalanceRemaining = child.balanceRemaining * child.pricePerUnit;
        count += child.balanceRemaining;
        total += child.totalBalanceRemaining;
        if (!child.childs) {
          child.childs = [];
        }
        let res = this.calculateBalanceRemainingChild(child);
        total += res.total;
        count += res.count;
      }
    });
    return { count: Number(count.toFixed(2)), total: Number(total.toFixed(2)) };
  }
  //#endregion

  //#region UNITS LOGIC
  initUnits() {
    this.unitService.unitList(this.organizationId).subscribe(
      (units: any) => {
        this.units = units;
        this.filterUnits('');
      },
      (error) => {
        console.error(error);
        this.toaster.show('error', '', 'An error occurred, please try again later.');
      },
    );
  }

  filterUnits(name: string) {
    this.filteredUnits = this.units.filter(
      (x) =>
        !this.financialReport.financialReportUnits.some((y) => x.name?.toLowerCase() == y.name?.toLowerCase()) &&
        x.name?.toLowerCase().includes(name?.toLowerCase()),
    );
  }

  onChangeUnitName(unit: FinancialReportUnitDto) {
    if (this.isUnitExist(unit)) {
      this.toaster.show('warning', '', 'Unit with this name already exist');
    }
  }
  //#endregion

  //#region SIGNERS LOGIC
  initSigners() {
    this.signerService.signerList(this.organizationId).subscribe(
      (signers: any) => {
        this.signers = signers;
      },
      (error) => {
        console.error(error);
        this.toaster.show('error', '', 'An error occurred, please try again later.');
      },
    );
  }

  selectSigner(event, financialReportSigner) {
    let signer = this.signers.find((x) => x.email == event.option.value);
    financialReportSigner.signerId = signer.id;
    financialReportSigner.isAdded = true;
    financialReportSigner.signer = signer;
    financialReportSigner.signer.signingOrder = signer.signingOrder;
  }

  filteredSigners(email: string, financialReportSigner: any) {
    return this.signers.filter(
      (x) =>
        !this.financialReport.financialReportSigners.some(
          (y) => x.email?.toLowerCase() == y.signer.email?.toLowerCase(),
        ) && x.email?.toLowerCase().includes(email?.toLowerCase() && financialReportSigner.signatureField == 'SIGNATURE' && x.signingOrder == 1 || financialReportSigner.signatureField.includes(x.signingOrder - 1)),
    );
  }
  //#endregion

  //#region TYPES LOGIC
  initTypes() {
    this.typesService.financialReportTypeList().subscribe((result) => {
      this.types = result;
      this.filterTypes('');
    });
  }

  addNewType() {
    const modalRef = this.modal.open(FinancialReportTypeModal, {
      size: 'lg',
      container: 'nb-layout',
      keyboard: false,
      windowClass: 'company-modal',
    });
    modalRef.componentInstance.modal = modalRef;
    modalRef.result.then(
      (result: any) => {
        this.initTypes();
      },
      (error) => {
        if (error) {
          const errMsg = error.error && error.error.detail ? error.error.detail : error.message;
          this.toaster.show('error', 'Financial Report Type', errMsg);
        }
      },
    );
  }

  selectType(event: MatAutocompleteSelectedEvent) {
    this.financialReport.financialReportType = event.option.value;
    this.financialReport.financialReportTypeId = this.financialReport.financialReportType.id;
    if (!this.financialReport.financialReportType.financialReportColumns) {
      this.financialReport.financialReportType.financialReportColumns = [];
    }
    if (this.financialReport.financialReportType) {
      this.financialReport.financialReportType.financialReportColumns = this.financialReport.financialReportType.financialReportColumns.sort((a, b) => {
        return a.order - b.order
      })
    }
    this.financialReport.financialReportUnits.forEach((unit: FinancialReportUnitInputPayload) => {
      this.setUnitColumns(unit);
    });
    // if (this.isCustomer() && this.checkStatus(this.statuses.draft)) {
    //   this.backendCurrentColumn = this.financialReport.financialReportType.financialReportColumns.length;
    // }
    this.financialReport.currentColumn = 1;
  }

  filterTypes(name: string) {
    this.filteredTypes = this.types.filter((x) => x.name?.toLowerCase().includes(name?.toLowerCase()));
  }

  displayWithType(type: FinancialReportTypeInputPayload) {
    return type ? type.name : '';
  }

  private setUnitColumns(unit: FinancialReportUnitInputPayload) {
    unit.columns = [];
    this.financialReport.financialReportType.financialReportColumns.forEach(
      (column: FinancialReportColumnInputPayload) => {
        unit.columns.push({ financialReportColumnID: column.id, financialReportUnitID: unit.id, value: 0 });
      },
    );

    let copyToAllLevels = (unit: FinancialReportUnitInputPayload) => {
      unit?.childs.forEach((child: FinancialReportUnitDto) => {
        child.columns = unit.columns;
        copyToAllLevels(child);
      });
    };

    copyToAllLevels(unit);
  }

  orderColumns(columns: LasgroFinancial_report_unit_column[]) {
    return columns.sort((a, b) => {
      const indexA = this.financialReport.financialReportType.financialReportColumns.findIndex(
        (item) => item.id === a.financialReportColumnID,
      );
      const indexB = this.financialReport.financialReportType.financialReportColumns.findIndex(
        (item) => item.id === b.financialReportColumnID,
      );
      return indexA - indexB;
    });
  }


  getVoucherColumnName() {
    let currentReportColumn = this.financialReport.financialReportType.financialReportColumns.find(
      (x) => x.order == this.financialReport.currentColumn,
    );
    return currentReportColumn ? '(' + currentReportColumn?.name + ')' : '';
  }

  //#endregion
}

export class FinancialReportStatuses {
  static draft = 'draft';
  static submitted = 'submitted';
  static waitingForSign = 'waiting for sign';
  static closed = 'closed';
}
